// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"loader_lds-ellipsis__Yx0m2","lds-ellipsis1":"loader_lds-ellipsis1__fxd75","lds-ellipsis2":"loader_lds-ellipsis2__r+sWz","lds-ellipsis3":"loader_lds-ellipsis3__s+qOS"};